import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../config/api";

export const submitNewFavorite = createAsyncThunk(
  "favorites/addToFavorites",
  async ({ trackId, remixId, trackMetadata }) => {
   
      const response = await api.post(`/favorite/add`, { trackId, remixId });
      return {
        ...response.data,
        trackId,
        remixId,
        ...trackMetadata 
      };
   
  }
);

export const removeFavoriteFromAPI = createAsyncThunk(
  "favorites/removeFromFavorites",
  async ({ trackId, remixId }) => {
   
      const response = await api.delete(`/favorite/remove`, {
        data: { trackId, remixId }
      });
      return { trackId, remixId, ...response.data };
   
  }
);

export const fetchFavorites = createAsyncThunk(
  "favorites/fetchFavorites",
  async ({ page = 1, limit = 50, sortBy = 'createdAt', sortOrder = 'desc', type } = {}) => {
   
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        sortBy,
        sortOrder
      });
      if (type) {
        queryParams.append('type', type);
      }
      const response = await api.get(`/favorite/?${queryParams.toString()}`);
      return response.data;
    
  }
);

export const clearAllFavorites = createAsyncThunk(
  "favorites/clearAllFavorites",
  async () => {
    
      const response = await api.delete(`/favorite/clear-all`);
      console.log("All favorites cleared successfully");
      return response.data;
    
  }
);

